type Config = {
  onInstall: (registration: ServiceWorkerRegistration) => void;
  onUpdate: (registration: ServiceWorkerRegistration) => void;
  onRegister: (registration: ServiceWorkerRegistration) => void;
};

export default function registerServiceWorker(config: Config) {
  if (!("serviceWorker" in navigator)) {
    return;
  }
  const serviceWorkerLocation =
    import.meta.env.MODE === "production"
      ? window.location.origin + "/service-worker.js"
      : window.location.origin + "/dev-sw.js?dev-sw";

  navigator.serviceWorker
    .register(serviceWorkerLocation, {
      type: import.meta.env.MODE === "production" ? "classic" : "module",
    })
    .then(
      (registration) => {
        config.onRegister(registration);
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;

          if (installingWorker === null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                config.onUpdate(registration);
              } else {
                config.onInstall(registration);
              }
            }
          };
        };
      },
      (error) => {
        console.error(`Service worker registration failed: ${error}`);
      }
    );
}
